<div *ngIf="this.partner" style="background-color: #F5F7F8; height: 100vh; overflow-y: hidden; padding: 10px;">
  <div style="height: 50px">
    <img
      style="z-index: 10000; width: 22px; height: 22px; float: left; margin-top: 20px; position: relative; left: 10px;"
      (click)="this.back()"
      src="/assets/images/shared/back.svg"
     alt="">
    <img
      style="z-index: 10000; width: 22px; height: 22px; float: right; margin-top: 20px; position: relative; right: 10px;"
      (click)="this.info()"
      src="/assets/images/partner/information.svg"
     alt="">
  </div>

  <div style="height: 170px">
    <img
      style="width: 65px; height: 65px; border-radius: 30px; margin: auto; display: block;"
      [src]="this.partnerImage"
      alt=""
    >
    <h3 style="text-align: center; font-weight: bold; margin-top: 5px;">{{ this.partner?.data?.name_in_latin }}</h3>
    <h5 style="text-align: center; margin-top: 10px; margin-bottom: 5px;">{{ this.locationAddress }}</h5>
    <h5 style="text-align: center; margin-top: 5px;">{{ this.workingTime }}</h5>
  </div>

  <cdk-virtual-scroll-viewport
    [itemSize]="170"
    [minBufferPx]="170"
    [maxBufferPx]="170"
    class="example-viewport"
    style="height: 70vh; overflow-x: hidden;"
  >
    <div *cdkVirtualFor="let item of ds; index as i; templateCacheSize: 0" class="example-item col-12" style="height: 170px;">
      <div *ngIf="item" style="height: 170px;">
        <div
          [matBadge]="item.is_in_group ? 'Групова поръчка' : ''"
          matBadgeColor="warn"
          matBadgePosition="before"
          (click)="this.openItem(item.uuid, 'none')"
          class="card mb-3"
          style="border: unset; max-width: 540px; padding: 10px; background-color: white; border-radius: 9px;"
        >
          <div class="row">
            <div class="col-4">
              <img [src]="item.imageURL" class="card-img img-fluid" style="height: 120px;" alt="...">
            </div>

            <div class="col-8" style="padding: 0px; padding-right: 5px;">
              <p
                style="margin-bottom: 5px; display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; height: 63px; overflow: hidden; text-overflow: ellipsis; margin-top: 5px;"
              >
                {{ item?.name || '' }}
              </p>

              <ngb-rating
                [readonly]="true"
                style="position: relative;"
                [rate]="item?.ratingAvgValue || 0"
                [max]="5"
              >
                <ng-template let-fill="fill" let-index="index">
                  <span class="star" [class.filled]="fill === 100">&#9733;</span>
                </ng-template>
              </ngb-rating>

              <span style="color: #b0c4de; font-size: 10px;">{{ ' (' + item.ratings!.data.length + ')' }}</span>

              <div *ngIf="this.getBasePriceAmount(item) !== null" style="margin-top: 5px;">
                <app-price
                  [amount]="this.getBasePriceAmount(item)!"
                  layout="inline"
                ></app-price>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
  <!-- Тук няма да има секция с услуги -->
</div>
